import React from "react";
import { useSpring, animated } from "react-spring";
import EpisodeList from "./EpisodeList";
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import PersonIcon from "@material-ui/icons/Person";
// import ThumbUpIcon from '@material-ui/icons/ThumbUp';
// import VisibilityIcon from '@material-ui/icons/Visibility';
// import TextsmsIcon from '@material-ui/icons/Textsms';
import stylesPc from "./ProgramDetail.module.css";
import stylesSp from "./ProgramDetail_SP.module.css";
import styleIpad from "./ProgramDetail_IP.module.css";
import { IsDevice } from "../../../components/function/useDeviceFlag";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardMedia from "@material-ui/core/CardMedia";
import { Button, CardActions, createStyles, makeStyles } from "@material-ui/core";

import { Video, RelatedVideo } from "../../../stores/program/model/Program";

import { useHistory } from "react-router-dom";
import PuiTooltip from "../../../components/elements/PuiTooltip ";
import PuiTypography from "../../../components/elements/PuiTypography";

interface FadeProps {
    children?: React.ReactElement;
    in: boolean;
    onEnter?: () => {};
    onExited?: () => {};
    onClose?: () => void;
    title: string;
    description?: string;
    episodelist?: Video[];
    selected?: Video;
    related?: RelatedVideo[];
}

const ProgramDetail = React.forwardRef<HTMLDivElement, FadeProps>(function ProgramDetail(
    props,
    ref
) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : IsDevice("ipad") ? styleIpad : stylesSp;

    const [selected, setSelected] = React.useState<Video | undefined>(props.selected);

    const history = useHistory();

    const { in: open, onEnter, onExited, onClose } = props;
    const style = useSpring({
        from: { opacity: 0 },
        to: { opacity: open ? 1 : 0 },
        onStart: () => {
            if (open && onEnter) {
                onEnter();
            }
        },
        onRest: () => {
            if (!open && onExited) {
                onExited();
            }
        },
    });

    // プログラム詳細のスタイル
    const useStyles = makeStyles(() =>
        createStyles({
            imgFullHeight: {
                left: 0,
                transform: "none",
            },
            imgFullWidth: {
                top: 0,
                transform: "none",
            },
            tag: {
                marginRight: "10px",
                marginBottom: "5px",
                borderRadius: "2em",
                backgroundColor: "var(--background-bg)",
                cursor: "default",
                pointerEvents: "none",
                border: "1px solid var(--secondary-bg)",
                opacity: "0.8",
                "&:hover": {
                    backgroundColor: "var(--red)",
                    boxShadow:
                        "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
                },
            },
            iconText: {
                color: "#ffffff",
                marginRight: "8px",
            },
            relatedVideoTitle: {
                fontSize: IsDevice("desktop") ? "20px" : "16px",
                position: "relative",
                marginTop: "-16px",
                marginLeft: "-24px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
            },
            divider: {
                margin: "10px -16px 8px -16px",
            },
            relatedVideoIconRow: {
                display: "flex",
                justifyContent: "space-evenly",
                marginLeft: "-24px",
                marginRight: "-16px",
                marginTop: "-8px",
            },
        })
    );
    const classes = useStyles();

    // タグリスト表示
    const makeTags = (episodeList: Video[]) => {
        let tags: string[] = [];
        for (let index = 0; index < episodeList.length; index++) {
            tags = tags.concat(episodeList[index].tags);
        }
        tags = tags.filter((value, index) => tags.indexOf(value) === index);
        const tagList: any[] = [];
        for (let i = 0; i < tags.length; i++) {
            tagList.push(
                <Button
                    key={i}
                    size="small"
                    color="secondary"
                    variant="contained"
                    className={classes.tag}
                >
                    <PuiTypography size={14} color="white">
                        {tags[i]}
                    </PuiTypography>
                </Button>
            );
        }
        return tagList;
    };

    // 文字列結合
    const formatStr = (episodeList: Video[]) => {
        let presenterList: string[] = [];
        let presenters = "";
        episodeList.map((item) => presenterList.push(item.presenter));
        presenterList = presenterList.filter(
            (value, index) => presenterList.indexOf(value) === index
        );
        presenterList.map((item) => (presenters += item + "、"));
        presenters = presenters.substring(0, presenters.length - 1);
        return presenters;
    };

    // フォーカスビデオの変更
    const onFocus = (focus: Video) => {
        setSelected(focus);
    };

    return (
        <animated.div ref={ref} style={style}>
            {/* {children} */}
            {!IsDevice("desktop") && (
                <div onClick={onClose} className={styles.closeButton}>
                    <img src={require("../../../assets/image/closeFilter.svg")} alt="close" />
                </div>
            )}
            <div className={styles.modalBody}>
                <div className={styles.detail}>
                    <div className={styles.detailTopArea}>
                        <div
                            className={styles.programTitle}
                            data-tip={props.title}
                            data-for="programTitle"
                        >
                            <PuiTypography size={20} bold={true} rows={1}>
                                {props.title}
                            </PuiTypography>
                        </div>
                        <PuiTooltip id={"programTitle"} />
                        <div
                            className={styles.programDescription}
                            data-tip={props.description}
                            data-for="programDescription"
                        >
                            <PuiTypography>{String(props.description)}</PuiTypography>
                        </div>
                        <PuiTooltip id={"programDescription"} />
                    </div>
                    <div className={styles.detailTopArea}>
                        <div className={styles.programRightTitle}>
                            <PuiTypography size={16} bold={true} color="gray-61" rows={1}>
                                出演Presenter
                            </PuiTypography>
                        </div>
                        <div className={styles.programProfessional}>
                            <PuiTypography size={16} bold={true}>
                                {String(props.episodelist && formatStr(props.episodelist))}
                            </PuiTypography>
                        </div>
                        <div className={styles.programRightTitle}>
                            <PuiTypography size={16} bold={true} color="gray-61">
                                Tags
                            </PuiTypography>
                        </div>
                        <div className={styles.tags}>
                            {props.episodelist && makeTags(props.episodelist)}
                        </div>
                    </div>
                </div>
                <div className={styles.detail}>
                    {selected && (
                        <div className={styles.selected}>
                            <img
                                src={selected.imageUrl}
                                className={styles.selectedImg}
                                alt={selected.title}
                            />
                            <div className={styles.titleBar}>
                                <div className={styles.professional}>
                                    <PersonIcon
                                        aria-hidden="true"
                                        style={{ width: 25, height: 25, color: "#ffffff" }}
                                    />
                                    <PuiTypography
                                        bold={true}
                                        color="white"
                                        rows={1}
                                    >{`Presenter：${selected.presenter}`}</PuiTypography>
                                </div>
                                <div
                                    className={styles.title}
                                    data-tip={selected.title}
                                    data-for="detailTitle"
                                >
                                    <PuiTypography bold={true} color="white" rows={1}>
                                        {selected.title}
                                    </PuiTypography>
                                </div>
                                <div
                                    className={styles.subtitle}
                                    data-tip={selected.description}
                                    data-for="detailSubtitle"
                                >
                                    <PuiTypography size={16} color="white">
                                        {selected.description}
                                    </PuiTypography>
                                </div>
                            </div>
                            <PuiTooltip id={"detailTitle"} />
                            <PuiTooltip id={"detailSubtitle"} />
                            <div className={styles.centerIcon}>
                                <PlayCircleFilledIcon
                                    style={
                                        IsDevice("desktop")
                                            ? { width: 100, height: 100, cursor: "pointer" }
                                            : IsDevice("ipad")
                                            ? { width: 100, height: 100, cursor: "pointer" }
                                            : { width: 50, height: 50, cursor: "pointer" }
                                    }
                                    onClick={() => history.push("./video/" + selected.id)}
                                />
                            </div>
                        </div>
                    )}
                    <div className={styles.episode}>
                        {props.episodelist && props.selected && (
                            <EpisodeList
                                itemList={props.episodelist}
                                title="エピソード"
                                imageShape="square"
                                selected={selected}
                                onCallback={onFocus}
                            />
                        )}
                    </div>
                </div>
                {props.related && props.related.length > 0 && (
                    <div>
                        <div className={styles.titleText}>
                            <PuiTypography size={20} bold={true} rows={1}>
                                こちらもおすすめ
                            </PuiTypography>
                        </div>
                        <div className={styles.spinoff}>
                            {props.related.map((item) => (
                                <Card
                                    key={item.id}
                                    className={styles.itemCard}
                                    onClick={() => history.push("./video/" + item.id)}
                                >
                                    <CardActionArea>
                                        <CardMedia
                                            className={styles.cardMedia}
                                            image={item.imageUrl}
                                        />
                                        <CardContent>
                                            <CardActions
                                                className={classes.relatedVideoTitle}
                                                data-tip={item.title}
                                                data-for="relatedVideoTitle"
                                            >
                                                <PuiTypography color="gray-61" bold={true} rows={1}>
                                                    {item.title}
                                                </PuiTypography>
                                                <PuiTooltip id={"relatedVideoTitle"} />
                                            </CardActions>
                                            <CardActions>
                                                <PersonIcon
                                                    aria-hidden="true"
                                                    style={{
                                                        width: 20,
                                                        height: 20,
                                                        color: "var(--gray-61)",
                                                        marginLeft: "-26px",
                                                        marginTop: "-17px",
                                                    }}
                                                />
                                                <div className={styles.iconTitle}>
                                                    <PuiTypography color="gray-61" rows={1}>
                                                        {item.presenter}
                                                    </PuiTypography>
                                                </div>
                                            </CardActions>
                                            {/* <Divider variant="fullWidth" className={classes.divider} />
                                            <CardActions className={classes.relatedVideoIconRow}>
                                                <div style={{display: "flex", alignItems: "center"}}>
                                                    <VisibilityIcon aria-hidden="true" style={{ color:'var(--gray-61)', marginRight:"8px"}}/>
                                                    <PuiTypography bold={true} color="gray-61" rows={1}>{String(item.viewCount)}</PuiTypography>
                                                </div>
                                                <div style={{display: "flex", alignItems: "center"}}>
                                                    <ThumbUpIcon aria-hidden="true" style={{ color:'var(--gray-61)', marginRight:"8px"}}/>
                                                    <PuiTypography bold={true} color="gray-61" rows={1}>{String(item.reactionsCount)}</PuiTypography>
                                                </div>
                                                <div style={{display: "flex", alignItems: "center"}}>
                                                    <TextsmsIcon aria-hidden="true" style={{ color:'var(--gray-61)', marginRight:"8px"}}/>
                                                    <PuiTypography bold={true} color="gray-61" rows={1}>{String(item.commentsCount)}</PuiTypography>
                                                </div>
                                            </CardActions> */}
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </animated.div>
    );
});
export default ProgramDetail;
